import {API} from '../../config/api'
import getToken from '../../utils/getToken'

export default async (data) => {
    try{
        const token = getToken()
        
        const responce = await fetch(`${API}/admin`,{
            method:'POST',
            headers:{
                'Authorization': `Bearer ${token}`
            },
            body:data
        })

        const {success,admin} = await responce.json()

        return {success,admin}

    }catch(error){
        console.log(error)
        return {success:false,error}
    }
}